import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { approvecourse, getCourseById  } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class viewcourse extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[]
    }
    this.id =  this.props.match.params.id;

  }
 

  componentDidMount() {

          var THIS = this;
  
          this.getCourse();  

  }

  
  getCourse(){

    let req = JSON.stringify({
        id:this.id
    })

    getCourseById(req).then(res => {
            if(res.status==1){
                let data=res.detail;
                this.setState({
                    course_name: data.course_name,
                    course_description: data.course_description,
                    course_duration_hrs: data.course_duration_hrs,
                    course_duration_months: data.course_duration_months,
                    course_duration_years: data.course_duration_years,
                    course_duration_days: data.course_duration_days,
                    course_eligibility: data.course_eligibility,
                    course_category:data.course_category,
                    course_certification:data.course_certificate_for,
                    course_certification_other:data.course_certificate_for_others,
                    course_fee: data.course_fee,
                    course_fee_currency:data.course_fee_currency,
                    course_fee_per: data.course_fee_per,
                    course_moreinfo_phone:data.course_moreinfo_phone,
                    course_moreinfo_email:data.course_moreinfo_email,
                    course_apply_url:data.course_apply_url,
                    course_banner:data.course_banner,
                    course_brochure:data.course_brochure,
                    course_status:data.course_status,
                    course_type:data.course_type
                })
            }
    });
}


unapprovecourse =(e) =>{

    let req = JSON.stringify({
        id:this.id,
        status:0
    })
    
    approvecourse(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Unapproved course successfully', 'Course Unapproval');

        setTimeout(function () {
            window.location.replace('/wiseconnect/courses');
        }, 1000);

      }else{
            
        NotificationManager.error('Error ', 'Course Unapproval');
      }

    });
}


rejectcourse =(e) =>{

    let req = JSON.stringify({
        id:this.id,
        status:2
    })
    
    approvecourse(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Rejcted successfully', 'Course Approval');

        setTimeout(function () {
            window.location.replace('/wiseconnect/courses');
        }, 1000);

      }else{
            
        NotificationManager.error('Error ', 'Course Approval');
      }

    });
}

approvecourse =(e) =>{

    let req = JSON.stringify({
        id:this.id,
        status:1
    })
    
    approvecourse(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Approved course successfully', 'Course Approval');

        setTimeout(function () {
            window.location.replace('/wiseconnect/courses');
        }, 1000);

      }else{
            
        NotificationManager.error('Error ', 'Course Approval');
      }

    });
}

 
  
 
  render() {
 const {value, suggestions, pickedones} = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                     
                        <h4 class="card-title">Course - View</h4>

                        <div class="courseinfo">

                        <div class="rowinfo">

                            <div class="infoitem">Course Name: <span>{this.state.course_name}</span> </div>
                            <div class="infoitem">Course Desc: <span>{this.state.course_description}</span> </div>

                        </div>

                        <div class="rowinfo">

                            <div class="infoitem">Course Type: <span>{this.state.course_type}</span> </div>
                            <div class="infoitem">Course Category: <span>{this.state.course_category}</span> </div>

                        </div>

                        <div class="rowinfo">

                            <div class="infoitem">Course Fee: <span>{this.state.course_fee_currency}{this.state.course_fee} {this.state.course_fee_per}</span> </div>
                            <div class="infoitem">Eligibility: <span>{this.state.course_eligibility}</span> </div>

                        </div>

                        <div class="rowinfo">

                            <div class="infoitem">Certificate For: <span>{this.state.course_certification}</span> </div>
                            <div class="infoitem">Certificate For if Other: <span>{this.state.course_certification_others}</span> </div>

                        </div>

                        <div class="rowinfo">

                            <div class="infoitem">Contact At: <span>Ph: {this.state.course_moreinfo_phone}, Email: {this.state.course_moreinfo_email} </span> </div>
                            <div class="infoitem">&nbsp;</div>

                        </div>

                        <div class="rowinfo">

                            <div class="infoitem">Banner: {this.state.course_banner!=''?<img src={"http://localhost:5005/"+this.state.course_banner} class="coursebanner" />:'None'}</div>
                            <div class="infoitem">Brochure: <a href={"http://localhost:5005/"+this.state.course_brochure} target='_blank'>click here</a></div>

                        </div>


                        <div class="rowinfo">

                        <div class="infoitem">Application URL: <span>{this.state.course_apply_url}</span> </div>
                        <div class="infoitem">&nbsp;</div>

                        </div>

                        <div class="rowinfo">

                        <div class="infoitem">Status: <span>{(this.state.course_status!=1)? (this.state.course_status==2)?"Rejected":"Waiting for approval":"Approved"}</span> </div>
                        <div class="infoitem">&nbsp;</div>

                        </div>


                        <div class="rowinfo">
                            {this.state.course_status==0 &&
                               <div>
                                    <button name="approve" class="btn btn-primary btn-sm" onClick={this.approvecourse}>Approve</button>&nbsp;<button name="reject" class="btn btn-primary btn-sm" onClick={this.rejectcourse}>Reject</button>
                                </div>
                            }

                            {this.state.course_status==1 &&
                                (<button name="approve" class="btn btn-primary btn-sm" onClick={this.unapprovecourse}>Unapprove</button>)
                            }
                        </div>

                        </div>

                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default viewcourse;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/viewcourse.jsx